<template>
    <div class="p-10">
        <template v-if="initAccount">
            <div class="text-2xl mb-4">Bienvenue !</div>
            <div class="mb-4">Pour commencer une nouvelle partie, un compte utilisateur doit être créé.</div>
            <!-- Formulaire Pseudo, Tel -->
            <form @submit.prevent="initToken">
                <div class="mb-4">
                    <label class="block mb-2" for="pseudo">Pseudo :</label>
                    <input v-model="form.pseudo" class="border p-2 w-full" type="text" id="pseudo" name="pseudo" required />
                </div>
                <div class="mb-4">
                    <label class="block mb-2" for="tel">Numéro de téléphone :</label>
                    <input v-model="form.tel" class="border p-2 w-full" type="tel" id="tel" name="tel" required />
                </div>
                <button :disabled="loadingCreate" class="bg-blue-500 text-white px-4 py-2 rounded" type="submit">
                    <template v-if="loadingCreate">
                        <i class="fas fa-spinner fa-spin"></i>
                    </template>
                    <template v-if="!loadingCreate">
                        Créer un compte et commencer
                    </template>
                </button>
            </form>
        </template>
        
        <template v-if="account">
            <template v-if="!account.spotify_refresh_token">
                <div class="text-2xl mb-4">Configuration Spotify requise !</div>
                <div class="mb-4">Pour profiter pleinement de l'expérience de jeu, veuillez connecter votre compte Spotify.</div>
                <a :href="'https://hister-api.va-net.fr/auth/spotify?token=' + account.token" class="bg-green-500 text-white px-4 py-2 rounded">
                    Connecter mon compte Spotify
                </a>
            </template>
            <template v-else>
                <div class="text-3xl font-bold mb-6 text-gray-800">Bienvenue, {{ account.nom }} ! 🎮</div>
                    <div class="mb-6 text-gray-600">Prêt à jouer ? Choisissez une option ci-dessous.</div>
                    <div class="mt-8 space-y-8">
                    <button @click="$router.push({name: 'CreatePartie'})" class="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-6 py-3 rounded-lg font-semibold shadow-md transition">
                        ▶ Commencer une nouvelle partie
                    </button>
                    <button @click="$router.push({name: 'JoinPartie'})" class="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-6 py-3 rounded-lg font-semibold shadow-md transition">
                        🔗 Rejoindre une partie existante
                    </button>
                    <button @click="logout" class="w-full bg-gray-400 hover:bg-gray-500 text-white px-6 py-3 rounded-lg font-semibold shadow-md transition">
                        🚪 Se déconnecter
                    </button>
                </div>
            </template>
        </template>

    </div>
</template>

<script>
export default {
    data() {
        return {
            initAccount: false,
            form: {
                pseudo: '',
                tel: ''
            },
            loadingCreate: false,
            
            account: null,
        }
    },
    methods: {
        async initToken() {
            if (!this.form.pseudo || !this.form.tel) {
                this.$toast.error('Veuillez remplir tous les champs.');
                return;
            }

            if (!/^(?:(?:\+|00)33|0)[1-9](?:\d{8}|\d{3}\d{2}\d{2}\d{2})$/.test(this.form.tel.replace(/\s/g, ''))) {
                this.$toast.error('Veuillez entrer un numéro de téléphone français valide.');
                return;
            }

            this.loadingCreate = true
            let response = await this.$request.post('create-account', this.form);
            this.loadingCreate = false

            if (response.id) {
                localStorage.setItem('user-token', response.token);
                location.reload();
                return;
            } else {
                this.$toast.error('Erreur lors de la création du compte.');
            }
        },

        async getAccount() {
            let response = await this.$request.post('get-account', {
                token: localStorage.getItem('user-token')
            });
            if (response.id) {
                this.account = response;
            } else {
                this.$toast.error('Erreur lors de la récupération du compte.');
            }
        },

        logout() {
            localStorage.removeItem('user-token');
            location.reload();
        }
    },
    mounted () {
        // localStorage.removeItem('user-token')
        if (!localStorage.getItem('user-token')) {
            this.initAccount = true;
        } else {
            this.getAccount()
        }
    },
}
</script>

<style lang="scss" scoped>

</style>